// extracted by mini-css-extract-plugin
export var marginNegative = "_7n-5 _7n-3 _7n-1";
export var marginPositive = "_7n-4 _7n-3 _7n-1";
export var modalContent = "_7n-6";
export var samplesTable = "_7n-8";
export var samplesTableContainer = "_7n-7";
export var statBox = "_7n-a";
export var tableCell = "_7n-1";
export var tableCellCenter = "_7n-2 _7n-1";
export var tableCellRight = "_7n-3 _7n-1";
export var tableHeader = "_7n-0";
export var trackingNumber = "_7n-9";